/* Mega menu hover fix (override) — keeps the dropdown open while the pointer
   is over the parent link OR the dropdown, closing only after the pointer
   has truly left the menu area. Applied via custom-liquid; overrides the
   HeaderMenu hover handlers bound in assets/global.js. */
(function () {
  function fixedOnMouseEnter() {
    clearTimeout(this.closeTimer);
    // (Original hover-intent open logic, simplified: open immediately on enter)
    clearTimeout(this.hoverIntentTimer);
    this.hoverIntentTimer = setTimeout(() => {
      if (this.mainDetailsToggle.open === false) {
        this.closeAnyOpenMegaMenus();
        this.classList.add('open');
        this.style.setProperty(
          '--link-end',
          `${Number.parseInt(this.offsetTop + this.getBoundingClientRect().height) - 1}px`
        );
        this.style.setProperty('--header-zindex', '1');
        this.summary.click();
      }
    }, 0);
  }

  function fixedOnMouseLeave(evt) {
    clearTimeout(this.hoverIntentTimer);
    clearTimeout(this.closeTimer);

    // If the pointer is moving directly to ANOTHER header-menu, close
    // immediately so two dropdowns never overlap.
    var to = evt && evt.relatedTarget;
    if (to && to.closest) {
      var toMenu = to.closest('header-menu');
      if (toMenu && toMenu !== this) {
        if (this.mainDetailsToggle.open && !this.preventHoverClose) {
          this.classList.remove('open');
          this.summary.click();
        }
        return;
      }
    }

    // Otherwise: grace period + robust check. If the pointer is still over
    // the menu element or any of its descendants (the dropdown), keep it
    // open. :hover matches the element and all its descendants.
    this.closeTimer = setTimeout(() => {
      if (this.matches(':hover')) {
        return;
      }
      if (this.mainDetailsToggle.open && !this.preventHoverClose) {
        this.classList.remove('open');
        this.summary.click();
      }
    }, 500);
  }

  function patchOne(menu) {
    if (menu.__megaHoverPatched) return;
    menu.__megaHoverPatched = true;
    // Remove the original handlers bound in global.js init()
    if (menu.mouseEnterHandler) {
      menu.removeEventListener('mouseenter', menu.mouseEnterHandler);
      menu.removeEventListener('mouseleave', menu.mouseLeaveHandler);
    }
    if (menu.summary) {
      if (menu.mouseLeaveSummaryHandler) {
        menu.summary.removeEventListener('mouseleave', menu.mouseLeaveSummaryHandler);
      }
      if (menu.mouseOverSummaryHandler) {
        menu.summary.removeEventListener('mouseover', menu.mouseOverSummaryHandler);
      }
    }
    // Bind the fixed handlers
    menu.mouseEnterHandler = fixedOnMouseEnter.bind(menu);
    menu.mouseLeaveHandler = fixedOnMouseLeave.bind(menu);
    menu.addEventListener('mouseenter', menu.mouseEnterHandler);
    menu.addEventListener('mouseleave', menu.mouseLeaveHandler);
  }

  function patchAll() {
    document.querySelectorAll('header-menu').forEach(patchOne);
  }

  // Patch existing instances once the element is defined/upgraded,
  // and watch for any added later (e.g. theme editor re-renders).
  function init() {
    patchAll();
    new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((n) => {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('header-menu')) patchOne(n);
          if (n.querySelectorAll) n.querySelectorAll('header-menu').forEach(patchOne);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (customElements.get('header-menu')) {
    // Already defined: upgrade may still be pending, wait a tick
    if (document.querySelector('header-menu')) {
      customElements.whenDefined('header-menu').then(() => setTimeout(init, 0));
    } else {
      init();
    }
  } else {
    customElements.whenDefined('header-menu').then(() => setTimeout(init, 0));
  }
})();
